import { CircleUser, FileBarChart2, Currency, GitPullRequest, NotebookPen} from "lucide-react";

const menuData: any = [
    {
        label: 'menu',
        isTitle: true,
    },
    {
        id: "dashboard",
        label: 'Clientes',
        link: "/#",
        icon: <CircleUser />,
        subItems: [
            {
                id: 'customers',
                label: 'Clientes',
                link: '/customers',
                parentId: "dashboard"
            }
        ]
    },

    {
        id: "financial",
        label: 'Finanzas',
        link: "/#",
        icon: <FileBarChart2 />,
        subItems: [
            {
                id: 'wallets',
                label: 'Carteras',
                link: '/wallets',
                parentId: "financial"
            },
            {
                id: 'transfers',
                label: 'Transferencias',
                link: '/transfers',
                parentId: "financial"
            },
            {
                id: 'transactions',
                label: 'Transacciones',
                link: '/transactions',
                parentId: "financial"
            }
        ]
    },
    {
        id: "gastosMenu",
        label: 'Movimientos',
        link: "/#",
        icon: <Currency />,
        subItems: [
            {
                id: 'gastos',
                label: 'Movimientos',
                link: '/movements',
                parentId: "gastosMenu"
            },
            {
                id: 'expenseCategories',
                label: 'Tipos de Movimientos',
                link: '/movementCategories',
                parentId: "gastosMenu"
            }
        ]
    },
    {
        id: "prestamosMenu",
        label: 'Prestamos',
        link: "/#",
        icon: <GitPullRequest />,
        subItems: [
            {
                id: 'quoter',
                label: 'Simulador de Prestamos',
                link: '/creditSimulator',
                parentId: "prestamosMenu"
            },
            {
              id: 'loans',
              label: 'Prestamos',
              link: '/loans',
              parentId: "prestamosMenu"
          },
            {
                id: 'loansApplications',
                label: 'Solicitudes de Prestamos',
                link: '/loanApplications',
                parentId: "prestamosMenu"
            },
            {
                id: 'loansPayments',
                label: 'Pago de Prestamos',
                link: '/loanPayments',
                parentId: "prestamosMenu"
            },
        ]
    },
    {
        id: "reportesMenu",
        label: 'Reportes',
        link: "/#",
        icon: <NotebookPen />,
        subItems: [
            {
                id: 'loanReport',
                label: 'Prestamos Activos',
                link: '/reports/activeLoans',
                parentId: "reportesMenu"
            },
            {
                id: 'loanPaymentReport',
                label: 'Pago de Prestamos',
                link: '/reports/loanPayments',
                parentId: "reportesMenu"
            },
            {
                id: 'expenseAndIncomeReport',
                label: 'Ingresos y Gastos',
                link: '/reports/expensesAndIncome',
                parentId: "reportesMenu"
            }
        ]
    },
    {
        id: "mantenimientoMenu",
        label: 'Mantenimientos creditos',
        link: "/#",
        icon: <GitPullRequest />,
        subItems: [
            {
                id: 'creditDestinations',
                label: 'Destinos de Prestamo',
                link: '/creditDestinations',
                parentId: "mantenimientoMenu"
            },
            {
                id: 'typeLoans',
                label: 'Tipos de Prestamo',
                link: '/typeLoans',
                parentId: "mantenimientoMenu"
            },
            {
                id: 'warrantyTypes',
                label: 'Tipos de Garantia',
                link: '/warrantyTypes',
                parentId: "mantenimientoMenu"
            }
        ],
    },
    {
        id: "mantenimientoClientes",
        label: 'Mantenimientos clientes',
        link: "/#",
        icon: <CircleUser />,
        subItems: [
            {
                id: 'economicActivityTypes',
                label: 'Tipos de Actividad Economica',
                link: '/economicActivityTypes',
                parentId: "mantenimientoClientes"
            }
        ],
    }
];

export { menuData };